<template>
  <iStyledCard
    class="card"
    :description-length="150"
    pointer-cursor-on-hover
    :focused="focused"
    single-column-metrics
    :metrics="metrics"
    show-border
    selectable
    @click="$emit('select')"
  >
    <template #title>
      <iSubHeading font-size="large">
        {{ title }}
      </iSubHeading>
    </template>
    <template #description>
      <iText font-size="small">
        {{ description }}
      </iText>
      <iSpace :height="10" />
    </template>
    <template #metrics>
      <iRow
        v-for="metric in metrics"
        :key="metric.name"
        gap="extraSmall"
        vertical-align="middle"
        wrap="nowrap"
      >
        <iIcon
          v-if="metric.icon"
          :icon="metric.icon"
          :variant="metric.iconVariant || 'primary'"
          disable-hover
        />
        <iText class="card-metric-value">
          {{ metric.value }}
        </iText>
        <iText class="card-metric-name">
          {{ metric.name }}
        </iText>
      </iRow>
    </template>
  </iStyledCard>
</template>

<script>
const ACCESS_CONTROL_FEATURE_LABELS = {
  canSignUp: "Anyone can sign-up",
  isPrivatePublication: "Accounts are required",
  requireAccountApproval: "Accounts require approval",
  requirePaidSubscription: "Paid subscription required",
};

export default {
  name: "PublicationSettingsCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    features: {
      type: Object,
      required: true,
    },
    focused: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["select"],
  computed: {
    metrics() {
      return Object.entries(this.features).map(([featureKey, isEnabled]) => {
        const name = ACCESS_CONTROL_FEATURE_LABELS[featureKey];
        if (!name) {
          // eslint-disable-next-line no-console
          console.error(
            "access control feature has no label and would render a blank row",
            { featureKey, title: this.title },
          );
        }
        return {
          name,
          icon: isEnabled ? "check-circle" : "close",
          iconVariant: isEnabled ? "branded" : "error",
        };
      }).filter(metric => Boolean(metric.name));
    },
  },
};
</script>

<style scoped>
.card {
  padding: 8px;
}
</style>
